import { gql } from '@apollo/client';

export default gql`
  mutation updateProductsWithSalesforceStatus($tickets: [TicketsWithCompensation!]!) {
    updateProductsWithSalesforceStatus(tickets: $tickets) @client
  }
`;
